<div class="hotspot" [class.active]="currentViewId === hotspot.GoToViewId && pulseMiniMapYouAreHereHotspot"
     [ngStyle]="{'transform': hotspot.ngStyle.Transform }">

     <div #hotspotElement class="hotspot-icon flex align-center justify-center" (click)="handleHotspotClick()">
          <div *ngIf="!hotspot.IconUrl" [innerHTML]="hotspot.IconSvgContent | safeHtml"></div>
          <div *ngIf="!!hotspot.IconUrl" [style.background-image]="hotspot.IconUrl | safeBackgroundImageUrl"></div>
     </div>

     <div *ngIf="radarIsEnabled" class="radar-cone" [style.transform]="radarStyleTransform"></div>
</div>